import { Map } from 'immutable';
import { initialState as itemsInitialState } from '../reducers/shopifyItems';
import { initialState as profilesInitialState } from '../reducers/shopifyProfiles';
import { peek, selector } from '../selectorHelpers';

// Profiles
export const selectShopifyProfiles = (state) =>
  state.get('shopifyProfiles', profilesInitialState);

export const shopifyProfilesSelectItems = selector(
  selectShopifyProfiles,
  peek('profiles'),
);
export const shopifyProfilesSelectLoading = selector(
  selectShopifyProfiles,
  peek('isLoading'),
);

// Items
export const selectShopifyItems = (state) =>
  state.get('shopifyItems', itemsInitialState);

export const shopifyItemsSelectByProfile = selector(
  selectShopifyItems,
  peek('itemsByProfile'),
);
export const shopifyItemsSelectLoading = selector(
  selectShopifyItems,
  peek('isLoading'),
);

// Derived: item_id -> state lookup from all profiles
export const shopifyItemsSelectExports = selector(
  selectShopifyItems,
  (shopifyItems) => {
    const itemsByProfile = shopifyItems.get('itemsByProfile', Map());
    let result = Map();
    itemsByProfile.forEach((profileItems) => {
      if (profileItems && profileItems.forEach) {
        profileItems.forEach((item) => {
          result = result.set(item.get('item_id'), item.get('state'));
        });
      }
    });
    return result;
  },
);
